import DataGrid, { Column, Item, LoadPanel, Paging, SearchPanel, Toolbar, Button as Butt, Editing, Pager } from 'devextreme-react/data-grid';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { AddIcon, CreateOrders, CreateOrdersWhite, filter, resButtonRefresh } from '../../../images/icons';
import { Button, Form, Tooltip } from 'devextreme-react';
import { Item as ItemF } from 'devextreme-react/form';
import './Quotations.scss';
import ModalCreateQuotation from './Modals/ModalCreateQuotation';
import { setData, setMode } from '../../../contexts/slices/quotations';
import { useAppDispatch, useAppSelector } from '../../../contexts/hooks';
import { useApiQuotation } from '../../../api/api.Quotations';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import moment from 'moment';
import { ModalReportQuotation } from '../../../components/library/reporting/ModalReportQuotations';
import { FormPopup, newToast } from '../../../components';
import { ModalCreateAppointment } from './Modals/ModalCreateAppointment';
import ConfirmationPopup from '../../../components/utils/popup-confirmation/PopupConfirmation';
import { useApiPreorders } from '../../../api/api.Preorders';
import ModalCreatePreOrder from '../../Preorders/Modals/ModalCreatePreOrder';

const currentFilters = {
  startDate: moment().format('YYYY-MM-DD'),
  endDate: moment().format('YYYY-MM-DD'),
};

const Index = () => {
  const gridRef = useRef<DataGrid>(null);
  const [ModalVisible, setModalVisible] = useState(false);
  const [visibleReport, setVisibleReport] = useState(false);
  const [loadingCreatePreorder, setLoadingCreatePreorder] = useState(false);
  const [modalFiltersVisible, setModalFiltersVisible] = useState(false);
  const [ModalCreateAppointmentVisible, setModalCreateAppointmentVisible] = useState(false);
  const [QuotationData, setQuotationData] = useState<any>(null);
  const [preOrderData, setPreOrderData] = useState<any>(null);
  const [currentDataDetalle, setCurrentDataDetalle] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  const [currentIdPreOrder, setCurrentIdPreOrder] = useState(-1);
  const [modalPreOrderVisible, setModalPreOrderVisible] = useState(false);
  const [modalCreatePreorderConfVisible, setModalCreatePreorderConfVisible] = useState(false);
  const Prm_Citas_C = useAppSelector((state) => state.userInfo.Permissions?.Prm_Citas_C);
  const { CreateFromQuotation } = useApiPreorders();
  const dispatch = useAppDispatch();
  const { GetByFilter, deleteQuotation } = useApiQuotation();

  const handleModalShowFilter = useCallback(() => {
    setModalFiltersVisible(!modalFiltersVisible);
  }, [modalFiltersVisible]);

  const fetchData = useCallback(async (startDate, endDate) => {
    gridRef.current?.instance?.beginCustomLoading('');
    const result = await GetByFilter(startDate, endDate);
    setDataSource(result);
    gridRef.current?.instance?.endCustomLoading();
  }, []);

  useEffect(() => {
    fetchData(currentFilters.startDate, currentFilters.endDate);
  }, [currentFilters, fetchData]);

  const customDataSrc = useMemo(() => {
    return new CustomStore({
      key: 'Cz_Id',
      load: () =>
        Promise.resolve({
          data: dataSource,
          totalCount: dataSource.length,
        }),
      remove: (key) => {
        return deleteQuotation(key).then((res) => {
          if (res) {
            fetchData(currentFilters.startDate, currentFilters.endDate);
          }
        });
      },
    });
  }, [dataSource]);

  const customData = useMemo(() => {
    return new DataSource({
      store: customDataSrc,
      reshapeOnPush: true,
    });
  }, [customDataSrc]);

  const handleNewClick = useCallback(() => {
    dispatch(setMode({ mode: 'new' }));
    setModalVisible(true);
  }, [setModalVisible]);

  const handleClose = useCallback(
    (update: boolean) => {
      if (update) {
        fetchData(currentFilters.startDate, currentFilters.endDate);
      }
      setModalVisible(false);
    },
    [setModalVisible, fetchData]
  );

  const handleUpdateData = useCallback(() => {
    setModalFiltersVisible(false);
    fetchData(currentFilters.startDate, currentFilters.endDate);
  }, [setModalFiltersVisible, fetchData]);

  const handleView = useCallback(
    (e) => {
      dispatch(setData(e.row.data));
      setCurrentDataDetalle(e.row.data.Detalle);
      setModalVisible(true);
    },
    [setModalVisible]
  );

  const handleCloseModalPrint = useCallback(() => {
    setVisibleReport(false);
  }, [setVisibleReport]);

  const handleClicPrint = useCallback(
    (e) => {
      setQuotationData(e.row.data);
      setVisibleReport(true);
    },
    [setVisibleReport]
  );

  const handleClicCreateAppointment = useCallback(
    (e) => {
      if (!Prm_Citas_C) {
        newToast('WARNING', 'No tienes permisos para crear citas', 3);
        return;
      }
      setQuotationData(e.row.data);
      //console.log(e.row.data);
      setModalCreateAppointmentVisible(true);
    },
    [setModalCreateAppointmentVisible]
  );

  const handleClicPreOrden = useCallback((e) => {
    const data = e.row.data;
    if (data.Cz_POrd_Id) {
      newToast('INFO', `Ya existe la preorden No. ${data.Cz_POrd_Id} asociada a esta cotización`, 4);
      return;
    }
    const transformedData: any = {};

    // Transformar las propiedades del encabezado
    Object.keys(data).forEach((key) => {
      if (key.startsWith('Cz_')) {
        const newKey = key.replace('Cz_', 'POrd_');
        transformedData[newKey] = data[key];
      }
    });

    // Transformar el detalle para incluir solo Rpre_Es_Id
    if (data.Detalle) {
      transformedData.Detalle = data.Detalle.map((detalle: any) => ({
        Rpre_Es_Id: detalle.Czd_Es_Id,
        Rpre_Imp_Id: detalle.Czd_Imp_Id,
        Rpre_Cantidad: detalle.Czd_Cantidad,
        Rpre_ValUnitario: detalle.Czd_ValUnitario,
        Rpre_ValTotal: detalle.Czd_ValTotal,
        Rpre_Descuento: detalle.Czd_Descuento,
        Rpre_Impuesto: detalle.Rpre_Impuesto,
      }));
    }

    delete transformedData.POrd_FechaCrea;
    delete transformedData.POrd_Cl_Id;
    delete transformedData.POrd_FechaCrea;
    delete transformedData.POrd_FechaExpira;
    delete transformedData.POrd_FechaInicial;
    delete transformedData.POrd_Id;
    delete transformedData.POrd_Numero;
    delete transformedData.POrd_Us_Id;

    transformedData.POrd_Cz_Id = data.Cz_Id;

    setPreOrderData(transformedData);
    setModalCreatePreorderConfVisible(true);
  }, []);

  const handleClicPreOrdenConfirm = useCallback(() => {
    if (preOrderData) {
      setLoadingCreatePreorder(true);
      CreateFromQuotation(preOrderData).finally(() => {
        setModalCreatePreorderConfVisible(false);
        fetchData(currentFilters.startDate, currentFilters.endDate);
        setLoadingCreatePreorder(false);
      });
    }
  }, [setModalCreatePreorderConfVisible, preOrderData]);

  const handleClicPreOrdenCancel = useCallback(() => {
    setModalCreatePreorderConfVisible(false);
  }, [setModalCreatePreorderConfVisible]);

  const handleFindPreOrder = useCallback(
    (idPreorden) => {
      setCurrentIdPreOrder(idPreorden);
      setModalPreOrderVisible(true);
    },
    [setCurrentIdPreOrder, setModalPreOrderVisible]
  );

  const handleClosePreOrder = useCallback(() => {
    setModalPreOrderVisible(false);
  }, [setModalPreOrderVisible]);

  return (
    <div className={'view crm-contact-list'}>
      <div className={'view-wrapper view-wrapper-contact-list'}>
        <DataGrid className='grid' dataSource={customData} ref={gridRef} height='100%' width={'100%'} repaintChangesOnly={false} highlightChanges={false} hoverStateEnabled={true} rowAlternationEnabled={true} showColumnLines={true}>
          <LoadPanel enabled={true} />
          <Editing allowUpdating={true} allowDeleting={true} />
          <SearchPanel visible placeholder='Buscar' />
          <Paging enabled={true} />
          <Pager visible={true} allowedPageSizes={[20, 50, 100, 'all']} displayMode='full' showPageSizeSelector={true} showInfo={true} showNavigationButtons={true} />
          <Toolbar>
            <Item location='before'>
              <div className='grid-header'>Cotizaciones</div>
            </Item>
            <Item location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
              <Tooltip target='#toolBarNew' showEvent='mouseenter' hideEvent='mouseleave' position='top'>
                Nueva cotización
              </Tooltip>
              <Button id='toolBarNew' text={'Nuevo'} stylingMode='outlined' icon={AddIcon} type='success' onClick={handleNewClick} />
            </Item>
            <Item location='after' locateInMenu='auto'>
              <div className='separator' />
            </Item>
            <Item location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
              <Tooltip target='.filter-button' showEvent='mouseenter' hideEvent='mouseleave' position='top'>
                Filtrar cotizaciones
              </Tooltip>
              <Button className='filter-button' icon={filter} text='Filtrar' stylingMode='text' onClick={handleModalShowFilter} />
            </Item>
            <Item location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
              <Tooltip target='.refresh-button' showEvent='mouseenter' hideEvent='mouseleave' position='top'>
                Refrescar datos
              </Tooltip>
              <Button className='refresh-button' icon={resButtonRefresh} text='Actualizar' stylingMode='text' onClick={handleUpdateData} />
            </Item>
            <Item name='searchPanel' locateInMenu='auto' />
          </Toolbar>
          <Column dataField='Cz_Id' caption='NRO.' alignment='center' width={70} />
          <Column
            dataField='POrd_Ord_Id'
            caption='PREORDEN'
            width={90}
            alignment='center'
            cellRender={({ data }: { data: any }) => {
              const CzId = data.Cz_Id;
              return (
                <div id={`ord${CzId}`}>
                  <img
                    src={data.Cz_POrd_Id ? CreateOrders : CreateOrdersWhite}
                    alt='Preorden'
                    onClick={() => {
                      handleFindPreOrder(data.Cz_POrd_Id);
                    }}
                  />
                  <Tooltip target={`#ord${CzId}`} showEvent='mouseenter' hideEvent='mouseleave' position='top'>
                    {data.Cz_POrd_Id ? `Ver preorden` : 'No hay orden asociada'}
                  </Tooltip>
                </div>
              );
            }}
          />
          <Column dataField='Usuario.Us_Usuario' caption='CREADO POR' alignment='center' width={150} />
          <Column dataField='Cz_FechaCrea' caption='FECHA' dataType='datetime' format='dd/mm/yyyy' alignment='center' width={150} />
          <Column
            dataField='Paciente'
            cellRender={handlePatientCellRender}
            calculateCellValue={(rowData) => {
              const { Pc_Nombre, Pc_Apellido1, Pc_Apellido2 } = rowData.Paciente;
              return `${Pc_Nombre} ${Pc_Apellido1} ${Pc_Apellido2}`;
            }}
            minWidth={200}
            caption='CLIENTE'
            alignment='left'
          />
          <Column
            dataField='Detalle'
            cellRender={handleDetailCellRender}
            calculateCellValue={(rowData) => {
              const Detalles = rowData.Detalle.map((x) => x.Estudio.Es_Abreviatura);
              return Detalles.join(', ');
            }}
            caption='EXÁMENES'
            alignment='left'
          />
          <Column dataField='Cz_Descuento' caption='DESCUENTO' dataType='number' format='currency' alignment='center' width={100} />
          <Column dataField='Cz_ValorTotal' caption='TOTAL' dataType='number' format='currency' alignment='center' width={100} />
          <Column type='buttons' caption={'ACCIÓN'} width={200}>
            <Butt icon='eyeopen' text='Ver' onClick={handleView} />
            <Butt icon='print' text='Imprimir' onClick={handleClicPrint} />
            <Butt icon='custom-create-orders' text='Crear preorden' onClick={handleClicPreOrden} />
            <Butt icon='custom-date' text='Crear cita' onClick={handleClicCreateAppointment} />
            <Butt name='delete' text='Eliminar' />
          </Column>
        </DataGrid>
      </div>
      {modalFiltersVisible && (
        <FormPopup title='Filtrar cotizaciones' visible={modalFiltersVisible} setVisible={handleModalShowFilter} onSave={handleUpdateData} loading={false} allowSave={false}>
          <Form formData={currentFilters} labelLocation='left' className='plain-styled-form'>
            <ItemF dataField='startDate' editorType='dxDateBox' label={{ text: 'Fecha inicial' }} />
            <ItemF dataField='endDate' editorType='dxDateBox' label={{ text: 'Fecha final' }} />
          </Form>
        </FormPopup>
      )}
      <ModalCreateQuotation visible={ModalVisible} setVisible={handleClose} currentData={currentDataDetalle} />
      <ModalReportQuotation visible={visibleReport} setVisible={handleCloseModalPrint} reportName='Cotizaciones' idQuotation={QuotationData ? QuotationData.Cz_Id : -1} />
      <ModalCreateAppointment visible={ModalCreateAppointmentVisible} setVisible={setModalCreateAppointmentVisible} quotationId={QuotationData ? QuotationData.Cz_Id : -1} patientDocument={QuotationData ? QuotationData.Paciente.Pc_Identificacion : ''} patientId={QuotationData ? QuotationData.Paciente.Pc_Id : -1} preorderId={-1}/>
      {preOrderData && <ConfirmationPopup visible={modalCreatePreorderConfVisible} message={`Desea crear la preorden para la cotización seleccionada`} onCancel={handleClicPreOrdenCancel} onConfirm={handleClicPreOrdenConfirm} loading={loadingCreatePreorder} />}
      {modalPreOrderVisible && currentIdPreOrder && <ModalCreatePreOrder visible={modalPreOrderVisible} idPreOrder={currentIdPreOrder} setVisible={handleClosePreOrder} />}
    </div>
  );
};

export default Index;

const handlePatientCellRender = (data: any) => {
  const { Pc_Nombre, Pc_Apellido1, Pc_Apellido2 } = data.data.Paciente;
  return (
    <div>
      {Pc_Nombre} {Pc_Apellido1} {Pc_Apellido2}
    </div>
  );
};

const handleDetailCellRender = (data: any) => {
  const Detalles: string[] = data.data.Detalle.map((x: any) => {
    return x.Estudio.Es_Abreviatura;
  });

  return <div>{Detalles.join(', ')}</div>;
};
